import React, { Component } from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import { imageSrc } from "../../util/PublicOrderAPI";
import "../shared/rtl-panel.css";

class ModelStorefront extends Component {
    handleFile = (e, uploadFn) => {
        const file = e.target.files && e.target.files[0];
        if (file) uploadFn(file);
        // allow re-selecting the same file
        e.target.value = "";
    };

    render() {
        return (
            <ProductConsumer>
                {(value) => {
                    const {
                        SF_imageModalOpen,
                        SF_selected,
                        SF_CloseImageModal,
                        SF_uploadImage,
                        SF_removeImage,
                        SF_uploading,
                    } = value;

                    if (!SF_imageModalOpen || !SF_selected) return null;

                    const product = SF_selected;
                    const images = Array.isArray(product.images) ? product.images : [];

                    return (
                        <div className="rs-modal" dir="rtl" onClick={SF_CloseImageModal}>
                            <div
                                className="rs-modal__panel rs-modal__panel--md"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="rs-modal__head">
                                    <h5 className="rs-modal__title">
                                        <i className="fas fa-images"></i>
                                        رەسمکانی: {product.name || product.code}
                                    </h5>
                                    <span className="rs-badge rs-badge--grey rs-num">
                                        {images.length}
                                    </span>

                                    <div className="rs-modal__actions">
                                        <button
                                            className="rs-btn rs-btn--danger rs-btn--sm"
                                            onClick={SF_CloseImageModal}
                                        >
                                            <i className="fas fa-times"></i>
                                            داخستن
                                        </button>
                                    </div>
                                </div>

                                <div className="rs-modal__body">
                                    <div className="rs-drop">
                                        <label
                                            className="rs-btn rs-btn--primary"
                                            style={{ cursor: "pointer" }}
                                        >
                                            {SF_uploading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                    بارکردن...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-upload"></i>
                                                    هەڵبژاردنی رەسم
                                                </>
                                            )}
                                            <input
                                                type="file"
                                                accept="image/jpeg,image/png,image/webp"
                                                hidden
                                                disabled={SF_uploading}
                                                onChange={(e) => this.handleFile(e, SF_uploadImage)}
                                            />
                                        </label>
                                        <p className="rs-drop__hint">
                                            JPEG / PNG / WebP — زۆرترین قەبارە ١٠MB
                                        </p>
                                    </div>

                                    {images.length === 0 ? (
                                        <div className="rs-empty">
                                            <i className="fas fa-image"></i>
                                            <p>هیچ رەسمیەک نییە</p>
                                        </div>
                                    ) : (
                                        <div className="rs-gallery">
                                            {images.map((image, i) => (
                                                <div className="rs-gallery__item" key={i}>
                                                    <img src={imageSrc(image)} alt="" />
                                                    <button
                                                        className="rs-gallery__rm"
                                                        onClick={() => SF_removeImage(image)}
                                                        title="سڕینەوە"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                }}
            </ProductConsumer>
        );
    }
}

export default ModelStorefront;
